import $ from 'jquery';
import UMasonry from "./../shared/UMasonry";

export const initSectionFilter = () => {
  const form = document.querySelector('.section-filters form');
  if (form) {
    form.addEventListener('change', onFilterChange)
  }
}

const onFilterChange = (e) => {
  const wrapperSelector = e.target.form.dataset.wrapper;
  const wrapper = document.querySelector(wrapperSelector);
  const url = getFilterRequestUrl(e.target.form);
  if (url, wrapper) {
    $.get(url, {}, (result)=> {
      wrapper.innerHTML = result;
      UMasonry.refresh();
      const total = document.querySelector('.children-total')
      if (total) {
        total.innerHTML = [...wrapper.querySelectorAll('.item-box')].length;
      }
    });
  }
}

const getFilterRequestUrl = (form) => {
  const path = form.getAttribute('action') + ".ajax";
  let que = '';
  const formData = new FormData(form);
  const taxonomyIds = getFormTaxonomyIds(form);
  taxonomyIds.forEach((taxonomyId) => {
    const values = formData.getAll(taxonomyId);
    if (values.length > 0) {
      que += que == '' ? '?' : '&';
      que += `${taxonomyId}=${values.join(',')}`;
    }
  });
  return path + que
}

const getFormTaxonomyIds = (form) => {
  const formData = new FormData(form);
  const taxonIds = [];
  for (let pair of formData.entries()) {
    if (taxonIds.indexOf(pair[0]) < 0) {
      taxonIds.push(pair[0]);
    }
  }
  return taxonIds;
}